import { render } from "./PageOutput.vue?vue&type=template&id=9cb7e9a2&scoped=true"
import script from "./PageOutput.vue?vue&type=script&lang=js"
export * from "./PageOutput.vue?vue&type=script&lang=js"

import "./PageOutput.vue?vue&type=style&index=0&id=9cb7e9a2&scoped=true&lang=scss"

import exportComponent from "/home/itube/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cb7e9a2"]])

export default __exports__